import { Card, Password } from 'components'
import { Heading } from 'components/Heading'
import { Input } from 'components/Input'
import { Button } from 'components/Button'
import { Link } from 'components/Link'
import { resetPassword } from 'api/auth'
import { displayErrors } from 'validators/utils'
// import { schema } from 'validators/resetPassword'
import logo from 'assets/images/performancefinance-header.png'
export const ResetPassword = ({ attrs: { code, email } }) => {
  let serverErrors
  let loading
  let success = false
  const formData = {
    resetCode: code,
    email: email,
    password: ''
  }
  const triggerPasswordReset = () => {
    serverErrors = null
    loading = true
    resetPassword(formData)
      .then(res => {
        loading = false
        success = true
      })
      .catch(err => {
        loading = false
        serverErrors = err.response
      })
  }
  return {
    view () {
      return m('.h-full.flex.flex-col.justify-center.items-center.bg-gray-100.h-screen.mx-auto',
        [
          m(Card, {
            classes: ['max-w-md']
          }, [
            m('.p-6', [
              m('img.mb-6', {
                src: logo,
                alt: 'Performance Finance'
              }),
              m(Heading, { classes: ['mb-2'] }, 'Reset Password'),
              success
                ? m('div', [
                  m('p.mt-4.mb-4', 'Password Reset. Please login.'),
                  m(Button, {
                    type: 'button',
                    variant: 'danger',
                    onclick () {
                      m.route.set('/login')
                    }
                  }, 'Login')
                ])
                : m('form.grid.gap-2', {
                  onsubmit (e) {
                    e.preventDefault()
                    triggerPasswordReset()
                  }
                }, [
                  m(Input, {
                    value: formData.email,
                    type: 'readonly'
                  }),
                  m(Password, {
                    label: 'New Password',
                    value: formData.password,
                    type: 'password',
                    required: true,
                    oninput (val) {
                      formData.password = val
                    }
                  }),
                  serverErrors
                    ? m('div', displayErrors(serverErrors))
                    : m('div', [
                      m('p.m-1', 'Passwords must be at least 8 characters'),
                      m('p.m-1', "Passwords must have at least one digit ('0'-'9')"),
                      m('p.m-1', "Passwords must have at least one lowercase ('a'-'z')"),
                      m('p.m-1', "Passwords must have at least one uppercase ('A'-'Z')")
                    ]),
                  m('.flex.justify-between.items-center', [
                    m(Link, {
                      classes: ['text-red-800', 'underline'],
                      href: '/login'
                    }, 'Login'),
                    m(Button, {
                      variant: 'danger',
                      loading
                    }, 'Reset Password')
                  ])
                ])
            ])
          ])
        ])
    }
  }
}
